import {DateField, useRecordContext} from 'react-admin';
import {Alert, AlertTitle} from '@mui/material';
import React from "react";

/**
 * Hinweis in order-show, wenn der Toolbot beim Admin-Reset nicht vollstaendig aufgeraeumt wurde (DEL-73).
 * Der Titel steht als Text, der Alert hat role="alert"; ohne Fehler wird nichts gerendert.
 */
export const ToolbotCleanupWarning = () => {
    const record = useRecordContext();
    if (!record?.toolbotCleanupError) {
        return null;
    }
    return (
        <Alert severity="warning" sx={{mb: 2}}>
            <AlertTitle>Toolbot nicht vollständig aufgeräumt</AlertTitle>
            {record.toolbotCleanupError}
            {record.toolbotCleanupFailedAt && (
                <>
                    {' · '}
                    <DateField source="toolbotCleanupFailedAt" showTime locales="de-DE"/>
                </>
            )}
        </Alert>
    );
};
